export default __webpack_public_path__ + "static/media/pgmico(11).0d7f1954.png";